import 'reflect-metadata';
import Vue, { CreateElement } from 'vue';
// plugins
import container from '@/plugins/services';
import '@/plugins/env';
import { OrugaConfig } from '@/plugins/oruga';
// entry component
import ElencoDetail from './ElencoDetail.vue';

new Vue({
    provide: {
        ...container.getAll()
    },
    created() {
        // @ts-ignore
        this.$oruga.config.setOptions(OrugaConfig);
    },
    render(h: CreateElement) {
        return h(ElencoDetail);
    }
}).$mount('#elenco-detail');
